import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function FiltrosAvanzados({ filtros, setFiltros, trabajadores, lotes }) {
  return (
    <Card className="mb-6">
      <CardContent className="pt-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="space-y-2">
            <Label className="text-sm">Buscar</Label>
            <Input
              placeholder="Buscar por título..."
              value={filtros.busqueda}
              onChange={(e) => setFiltros({ ...filtros, busqueda: e.target.value })}
            />
          </div>

          <div className="space-y-2">
            <Label className="text-sm">Prioridad</Label>
            <Select
              value={filtros.prioridad || undefined}
              onValueChange={(value) => setFiltros({ ...filtros, prioridad: value === 'todos' ? '' : value })}
            >
              <SelectTrigger>
                <SelectValue placeholder="Todas" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="todos">Todas</SelectItem>
                <SelectItem value="alta">🔴 Alta</SelectItem>
                <SelectItem value="media">🟡 Media</SelectItem>
                <SelectItem value="baja">🟢 Baja</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label className="text-sm">Responsable</Label>
            <Select
              value={filtros.responsableId || undefined}
              onValueChange={(value) => setFiltros({ ...filtros, responsableId: value === 'todos' ? '' : value })}
            >
              <SelectTrigger>
                <SelectValue placeholder="Todos" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="todos">Todos</SelectItem>
                {trabajadores.map((trab) => (
                  <SelectItem key={trab.id} value={trab.id}>
                    {trab.nombre_completo}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label className="text-sm">Lote</Label>
            <Select
              value={filtros.loteId || undefined}
              onValueChange={(value) => setFiltros({ ...filtros, loteId: value === 'todos' ? '' : value })}
            >
              <SelectTrigger>
                <SelectValue placeholder="Todos" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="todos">Todos</SelectItem>
                {lotes.map((lote) => (
                  <SelectItem key={lote.id} value={lote.id}>
                    {lote.nombre}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
